import Modal from "@/components/shared/modal";
import { useState, Dispatch, SetStateAction, useCallback, useMemo } from "react";
import { getLocalizedPath } from "@/components/shared/formatURL";
import { useGenerator } from "@/app/context/GeneratorContext";

type TagWarningModalProps = {
  id: number;
  showTagWarningModal: boolean;
  setShowTagWarningModal: Dispatch<SetStateAction<boolean>>;
  translations: any;
};

const TagWarningModal = ({
  id,
  showTagWarningModal,
  setShowTagWarningModal,
  translations,
}: TagWarningModalProps) => {
  const { state } = useGenerator();

  const handleCancelButton = () => {
    setShowTagWarningModal(false);
  };

  return (
    <Modal showModal={showTagWarningModal} setShowModal={setShowTagWarningModal}>
      <div className="w-full overflow-hidden border-0 border-[#3C3C3C] shadow-xl sm:border-[0.5px] md:max-w-md md:rounded-2xl">
        <div className="flex flex-col items-center justify-center space-y-3 border-b-[0.5px] border-[#3C3C3C] bg-[#202124] px-4 py-6 text-center md:px-16">
          <p
            className="text-center
                font-semibold uppercase 
                text-transparent  text-white "
          >
            {translations.redirectWarning}
          </p>
        </div>
        <div className="flex flex-row gap-4 bg-[#313338] px-4 py-6 md:px-16">
          <a
            className="mt-auto w-full lg:mb-auto lg:mt-auto "
            rel="noopener noreferrer"
            href={getLocalizedPath(
              `tags?group=${id}&style=${state.selectedGenerator.shortName}&browse=true`,
            )}
          >
            <button className="my-0 inline-flex h-10 w-full transform items-center justify-center whitespace-nowrap rounded-md bg-[#0778e8] px-4 py-2 text-sm font-black italic text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50">
              {translations.continue}
            </button>
          </a>
          <button
            onClick={handleCancelButton}
            className="my-0 inline-flex h-10 w-full transform items-center justify-center whitespace-nowrap rounded-md bg-[#ff2424c2] px-4 py-2 text-sm font-black italic text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"
          >
            {translations.cancel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export function useTagWarningModal(id: number, translations: any) {
  const [showTagWarningModal, setShowTagWarningModal] = useState(false);

  const TagWarningModalCallback = useCallback(() => {
    return (
      <TagWarningModal
        id={id}
        showTagWarningModal={showTagWarningModal}
        setShowTagWarningModal={setShowTagWarningModal}
        translations={translations}
      />
    );
  }, [showTagWarningModal, setShowTagWarningModal, id]);

  return useMemo(
    () => ({ setShowTagWarningModal, TagWarningModal: TagWarningModalCallback }),
    [setShowTagWarningModal, TagWarningModalCallback],
  );
}
